module.exports = __webpack_public_path__ + "img/wicc.eea25ca9.svg";